import { get as getJson } from 'api'

export const getList = async request => getJson('/CustomsDeclarations/getList', request)

export const getDetail = async (sefCustomsDeclarationId, version) =>
  getJson(`/customsDeclarations/${sefCustomsDeclarationId}/Detail`, version != null ? { version } : undefined)

export const getItemDetail = async (sefCustomsDeclarationId, version, itemOrdinalNumber) =>
  getJson(`/customsDeclarations/${sefCustomsDeclarationId}/version/${version}/items/${itemOrdinalNumber}`)
